import { keyframes } from 'styled-components';

export const FADE_IN_TIME = '0.3s';

export const fadeIn = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
		}`;
